import {
  Box,
  Button,
  IconButton,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import LabeledBox from '../../special/LabeledBox';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../../global/theme/tokens';

const TypeBookingLocations = ({
  field,
  dataCollection,
  updateValidationOnChange,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const locations = dataCollection[field.key] || [];

  function updateLocations(newLocations) {
    updateValidationOnChange(field.key, newLocations);
  }

  function handleAdd() {
    updateLocations([
      ...locations,
      { label: '', street: '', house_number: '', zip_code: '', city: '' },
    ]);
  }

  function handleRemove(index) {
    updateLocations(locations.filter((_, i) => i !== index));
  }

  function handleChange(index, key, value) {
    const newLocations = [...locations];
    newLocations[index] = { ...newLocations[index], [key]: value };
    updateLocations(newLocations);
  }

  return (
    <LabeledBox
      label={field.label}
      sx={{ padding: '10px 0px', cursor: 'unset!important' }}
    >
      <Box className="flex flex-col gap-3">
        {locations.map((loc, index) => (
          <Box
            key={index}
            className="flex flex-col gap-2 p-3 rounded-lg"
            sx={{
              bgcolor: colors.bgInput,
              border: `1px solid ${colors.selected}`,
            }}
          >
            <Box className="flex items-center justify-between">
              <Box className="flex items-center gap-1">
                <LocationOnIcon fontSize="small" sx={{ opacity: 0.6 }} />
                <Typography variant="subtitle2" fontWeight={600}>
                  {t('Location')} {index + 1}
                </Typography>
              </Box>
              <IconButton
                size="small"
                onClick={() => handleRemove(index)}
                color="error"
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Box>

            <TextField
              label={t('Label')}
              value={loc.label || ''}
              onChange={(e) => handleChange(index, 'label', e.target.value)}
              size="small"
              fullWidth
              placeholder={t('e.g. Headquarters')}
            />

            <Box className="flex gap-2">
              <TextField
                label={t('Street')}
                value={loc.street || ''}
                onChange={(e) => handleChange(index, 'street', e.target.value)}
                size="small"
                fullWidth
              />
              <TextField
                label={t('House Nr.')}
                value={loc.house_number || ''}
                onChange={(e) =>
                  handleChange(index, 'house_number', e.target.value)
                }
                size="small"
                sx={{ width: '120px', minWidth: '120px' }}
              />
            </Box>

            <Box className="flex gap-2">
              <TextField
                label={t('ZIP Code')}
                value={loc.zip_code || ''}
                onChange={(e) =>
                  handleChange(index, 'zip_code', e.target.value)
                }
                size="small"
                sx={{ width: '120px', minWidth: '120px' }}
              />
              <TextField
                label={t('City')}
                value={loc.city || ''}
                onChange={(e) => handleChange(index, 'city', e.target.value)}
                size="small"
                fullWidth
              />
            </Box>
          </Box>
        ))}

        <Button
          size="small"
          color="secondary"
          onClick={handleAdd}
          sx={{ alignSelf: 'flex-start', paddingLeft: '2px' }}
        >
          <AddCircleIcon color="success" fontSize="small" sx={{ mr: 0.5 }} />
          {t('Add Location')}
        </Button>
      </Box>
    </LabeledBox>
  );
};

export default TypeBookingLocations;
